// 12 May 2026 JCH: Single place for "how do we read/write claim dates" so EditClaim.vue and
// FirmClaimsTable.vue stay in sync. Includes the API-format auto-flip below — once NC-1573
// is fully deployed and the API stops accepting "DD MMM YYYY", that section can be deleted
// (and toApiDate simplified to always emit ISO) without touching consumers.
import moment from 'moment';

const PARSE_FORMATS = ['YYYY-MM-DD', 'DD MMM YYYY', 'D MMM YYYY'];

// --- API format auto-flip (transitional, see NC-1573) -----------------------
// First time we see an ISO date in a /api/claims/{id} response, cache that and
// future saves follow suit. Defaults to legacy "DD MMM YYYY" until then.
const FALLBACK_API_FORMAT = 'DD MMM YYYY';
const DETECT_FIELDS = ['engaged', 'error', 'claim', 'report', 'clm_ack', 'first_rep', 'last_rep', 'close'];
let detectedApiFormat = null;

export function detectClaimDateApiFormat(claim) {
  if (!claim) return;
  for (const f of DETECT_FIELDS) {
    const v = claim[f];
    if (v === null || v === undefined || String(v).trim() === '') continue;
    const raw = String(v).trim();
    if (moment(raw, 'YYYY-MM-DD', true).isValid()) { detectedApiFormat = 'YYYY-MM-DD'; return; }
    if (moment(raw, ['DD MMM YYYY', 'D MMM YYYY'], true).isValid()) { detectedApiFormat = 'DD MMM YYYY'; return; }
  }
}

export function getClaimDateApiFormat() {
  return detectedApiFormat || FALLBACK_API_FORMAT;
}

export function isClaimDateApiFormatDetected() {
  return detectedApiFormat !== null;
}

// --- Date conversions -------------------------------------------------------

// Any input → YYYY-MM-DD for v-date-picker, or null if it can't be parsed.
export function toIsoDate(value) {
  if (value === null || value === undefined) return null;
  if (typeof value === 'number' && Number.isFinite(value)) {
    const m = moment(value);
    return m.isValid() ? m.format('YYYY-MM-DD') : null;
  }
  const raw = String(value).trim();
  if (!raw) return null;
  const strict = moment(raw, PARSE_FORMATS, true);
  if (strict.isValid()) return strict.format('YYYY-MM-DD');
  const fallback = moment(raw);
  return fallback.isValid() ? fallback.format('YYYY-MM-DD') : null;
}

// Any input → "DD MMM YYYY" for the UI, or '' (never moment's "Invalid date" string).
export function toDisplayDate(value) {
  const iso = toIsoDate(value);
  return iso ? moment(iso, 'YYYY-MM-DD').format('DD MMM YYYY') : '';
}

// Any input → format the API expects right now, or null if unparseable.
export function toApiDate(value) {
  const iso = toIsoDate(value);
  return iso ? moment(iso, 'YYYY-MM-DD').format(getClaimDateApiFormat()) : null;
}
